import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            为什么选择我们
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            五大核心优势，打造极致观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-100 rounded-xl border border-background-200/70 p-5 md:p-6 text-center hover:border-primary-200 transition-all duration-200"
            >
              <div className="w-12 h-12 mx-auto flex items-center justify-center bg-primary-100 rounded-xl text-primary-600">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="mt-4 text-sm font-semibold text-foreground-900 whitespace-nowrap">{feature.title}</h3>
              <p className="mt-2 text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}